import axios from "axios";
import store from "@/store";
import Swal from "sweetalert2";


const instance = axios.create({
  baseURL: process.env.VUE_APP_ACARA_WEB_BACKEND_URL || "http://localhost:8000/api/v1",
  withCredentials: false,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});


instance.interceptors.request.use(
  (config) => {
    const token = store.getters.getToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("No se encontró token de autenticación");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const isExpiredToken =
      error.response?.status === 401 ||
      (error.response?.status === 500 && error.response?.data?.message === "[Keycloak Guard] Expired token");

    if (isExpiredToken) {
      console.error("Sesión expirada detectada. Redirigiendo...");

      if (!Swal.isVisible()) {
        Swal.fire({
          title: "Sesión expirada",
          text: "Parece que tú sesión ha expirado, por favor vuelve a iniciar sesión",
          icon: "warning",
          confirmButtonText: "Aceptar",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor: "#007bff",
        }).then(() => {
          store.commit("clearUser");
          localStorage.clear();
          window.location.href = "/";
        });
      }
    }
    return Promise.reject(error);
  }
);

const plainInstance = axios.create({
  baseURL: process.env.VUE_APP_ACARA_WEB_BACKEND_URL || "http://localhost:8000/api/v1",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
});


export { instance as default, plainInstance };
